import { useState } from "react";

export default function PasswordInput({ id, label, placeholder, value, onChange, required, autoComplete = "new-password" }) {
  const [show, setShow] = useState(false);
  return (
    <div className="mjti-field">
      <label className="mjti-field__label" htmlFor={id}>{label}</label>
      <div className="mjti-password-field">
        <input
          id={id}
          className="mjti-field__input"
          type={show ? "text" : "password"}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          required={required}
          autoComplete={autoComplete}
        />
        <button
          type="button"
          className="mjti-password-toggle"
          onClick={() => setShow((s) => !s)}
          aria-label={show ? "Hide password" : "Show password"}
        >
          {show ? "Hide" : "Show"}
        </button>
      </div>
    </div>
  );
}
